
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorMapIcon as ObiCursorMapIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-map-icon.js';
 
 
 

 
 export const ObiCursorMapIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-map-icon',
   elementClass: ObiCursorMapIconElement,
   events: {
     
   }
  });
 
 